export const isPublicApiEndpoint = (path = '') =>
  path === '/api/v1/auth/login' ||
  path === '/api/v1/auth/register' ||
  path === '/api/v1/auth/forgot-password' ||
  path === '/api/v1/auth/reset-password' ||
  path === '/api/v1/scheduling/schedulesummary' ||
  path.startsWith('/api/v1/signing/public') ||
  path.startsWith('/api/v1/extrawork/signature') ||
  /\/api\/v1\/extrawork\/[^/]+\/(approve|reject|complete)$/.test(path)
